/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Agents_Title_1Inputs */

const en_services_svc_agents_title_1 = /** @type {(inputs: Services_Svc_Agents_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A team of agents.`)
};

const lv_services_svc_agents_title_1 = /** @type {(inputs: Services_Svc_Agents_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģentu komanda.`)
};

/**
* | output |
* | --- |
* | "A team of agents." |
*
* @param {Services_Svc_Agents_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_agents_title_1 = /** @type {((inputs?: Services_Svc_Agents_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Agents_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_agents_title_1(inputs)
	return en_services_svc_agents_title_1(inputs)
});